var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoleaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 181.9 132",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M93.1,51.3l-0.7-1.3L92,49.2l-2.6-4.9l-2.6,4.9l-0.4,0.7l-0.7,1.3c1.1-0.5,2.3-0.8,3.6-0.8 C90.7,50.4,92,50.7,93.1,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M42.1,110.7c0,7.6,5.6,12.6,14.2,12.6c8.6,0,14.2-5,14.2-12.6c0-7-5.6-12.7-14.2-12.7 C47.8,98,42.1,103.7,42.1,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M172,121.1l-12.4-22.3l-12.4,22.3c3.6-2.8,8-4.5,12.4-4.5C164,116.6,168.4,118.3,172,121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M39.3,110.7c0,8.5,6.9,15,17.1,15s17.1-6.6,17.1-15c0-8.4-7-15-17.1-15C46.3,95.6,39.3,102.2,39.3,110.7z M70.5,110.7c0,7.6-5.6,12.6-14.2,12.6c-8.6,0-14.2-5-14.2-12.6c0-7,5.6-12.7,14.2-12.7C64.9,98,70.5,103.7,70.5,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M105.2,124c0-1-0.6-1.7-1.7-1.7H83.4V98.2c0-1-0.6-1.7-1.7-1.7h-0.9v28.3h24.4V124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M135.1,98.9c1.1,0,1.7-0.7,1.7-1.7v-0.8h-26.4v28.3h27.5V124c0-1-0.6-1.7-1.7-1.7h-23.3V111h16.6v-2.4 h-16.6v-9.6H135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M159.6,119.3c4.4,0,9.2,1.8,12.8,4.8c0.9,0.7,1.1,0.8,3.5,0.8h1l-15.8-28.4c-0.3-0.6-0.9-0.9-1.5-0.9 s-1.2,0.3-1.5,0.9l-15.8,28.4h1c2.3,0,2.6,0,3.5-0.8C150.4,121.1,155.2,119.3,159.6,119.3z M159.6,98.8l12.4,22.3 c-3.6-2.8-8-4.5-12.4-4.5c-4.4,0-8.8,1.7-12.4,4.5L159.6,98.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M18.1,123.1c-4.4,0-8.4-1-12.2-3.2c-0.3-0.1-0.6-0.2-0.9-0.2c-0.5,0-1,0.3-1.4,0.8l-0.6,0.9 c4,2.7,9.2,4.2,15.6,4.2c9.5,0,14.6-3.4,14.6-9.1c0-12.6-26.6-3.6-26.6-12.7c0-3.4,3.8-5.5,10.9-5.5c3.9,0,7.4,0.6,10.7,2.3 c0.2,0.1,0.5,0.2,0.7,0.2c0.5,0,0.9-0.2,1.2-0.6l0.9-1c-3.3-2.3-7.8-3.3-13.7-3.3c-8.9,0-13.7,3.1-13.7,8.2 c0,12.1,26.6,2.8,26.6,12.5C30.3,120.6,26.1,123.1,18.1,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M85.5,52.4c1.1-0.7,2.5-1.1,3.9-1.1c1.4,0,2.8,0.4,3.9,1.1h1.4c0,0,0,0,0,0h0l-4.9-9.1 c-0.2-0.4-0.7-0.4-0.9,0L84,52.4h0c0,0,0,0,0,0H85.5z M86.4,49.9l0.4-0.7l2.6-4.9l2.6,4.9l0.4,0.7l0.7,1.3 c-1.1-0.6-2.3-0.9-3.7-0.9c-1.3,0-2.6,0.3-3.6,0.8L86.4,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M63.2,46.9l15,0.2c1.5,0,2.9-0.8,3.7-2.1c0.8-1.4,0.8-3,0-4.2l-7.7-12.8c-0.3,0.2-0.6,0.4-0.9,0.7l7.7,12.8 c0.6,0.9,0.6,2.1,0,3.1c-0.6,1-1.6,1.6-2.7,1.6l-14.9-0.2C63.2,46.1,63.2,46.5,63.2,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M70.2,40.1L64.7,40c-0.1,0.4-0.3,0.7-0.4,1.1l5.9,0.1c1,0,2-0.5,2.5-1.5c0.5-0.9,0.5-2,0-2.9l-3-5 c-0.3,0.3-0.5,0.6-0.8,0.9l2.8,4.7c0.5,0.8,0.2,1.5,0,1.8C71.6,39.5,71.1,40.1,70.2,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M78.5,25.3l7.2,13.1c0.6,1.1,1.5,1.8,2.7,2c0.3,0.1,0.6,0.1,0.9,0.1c1.6,0,3-0.8,3.7-2.1l7.3-13 c-0.3-0.2-0.7-0.3-1-0.4l-7.3,13c-0.5,1-1.5,1.5-2.7,1.5c-1.2,0-2.2-0.6-2.7-1.6l-7.2-13C79.2,25,78.8,25.1,78.5,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M88.8,30c0.2,0,0.4,0.1,0.6,0.1c1.1,0,2-0.5,2.5-1.5l2.9-5.1c-0.4-0.1-0.8-0.2-1.1-0.2L91,28 c-0.4,0.8-1.2,0.9-1.6,0.9c-0.3,0-1.1-0.1-1.6-0.9l-2.7-4.8c-0.4,0.1-0.8,0.1-1.1,0.2l2.8,5.1C87.3,29.3,87.9,29.8,88.8,30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M100.5,45.8c-1.1,0-2.1-0.6-2.7-1.6c-0.6-1-0.6-2.2,0-3.1l7.7-12.7c-0.3-0.2-0.6-0.4-0.9-0.7l-7.8,12.7 c-0.8,1.3-0.8,2.9,0,4.2c0.6,1.1,1.6,1.8,2.7,2.1c0.3,0.1,0.6,0.1,0.9,0.1l15.1-0.1c0-0.4-0.1-0.7-0.1-1.1L100.5,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M109.8,32.7c-0.2-0.3-0.5-0.6-0.7-0.9l-3.1,5c-0.6,0.9-0.6,2,0,2.9c0.4,0.8,1.1,1.3,1.9,1.4 c0.2,0,0.4,0.1,0.6,0.1l5.9,0c-0.1-0.4-0.2-0.7-0.4-1.1l-5.6,0c-0.9,0-1.4-0.6-1.5-0.9c-0.2-0.3-0.5-1,0-1.8L109.8,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M63.3,53l14.9-0.2c1.1,0,2.1,0.5,2.7,1.6c0.6,1,0.6,2.2,0,3.1l-7.7,12.8c0.3,0.2,0.6,0.4,0.9,0.7l7.7-12.8 c0.8-1.3,0.8-2.9,0-4.2c-0.8-1.4-2.2-2.2-3.7-2.1l-15,0.2C63.2,52.3,63.2,52.6,63.3,53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M68.9,66.1c0.2,0.3,0.5,0.6,0.8,0.9l3-5c0.5-0.9,0.6-2,0-2.9c-0.5-0.9-1.5-1.5-2.5-1.5l-5.9,0.1 c0.1,0.4,0.2,0.7,0.4,1.1l5.5-0.1c0.9,0,1.4,0.6,1.6,0.9s0.5,1,0,1.8L68.9,66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M79.5,73.9l7.2-13c0.5-1,1.5-1.6,2.7-1.6c1.2,0,2.2,0.6,2.7,1.5l7.3,13c0.3-0.1,0.7-0.3,1-0.4l-7.3-13 c-0.7-1.3-2.1-2.1-3.7-2.1c-0.3,0-0.6,0-0.9,0.1c-1.2,0.3-2.2,1-2.7,2l-7.2,13.1C78.8,73.6,79.2,73.8,79.5,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M89.4,68.7c-0.2,0-0.4,0-0.6,0.1c-0.8,0.2-1.5,0.7-1.9,1.4L84,75.3c0.4,0.1,0.8,0.1,1.1,0.2l2.7-4.8 c0.4-0.8,1.2-0.9,1.6-0.9c0.3,0,1.1,0.1,1.6,0.9l2.7,4.8c0.4-0.1,0.8-0.1,1.1-0.2l-2.9-5.1C91.4,69.3,90.5,68.7,89.4,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M100.5,52.9l15,0.1c0-0.4,0.1-0.7,0.1-1.1l-15.1-0.1c-0.3,0-0.6,0-0.9,0.1c-1.1,0.2-2.1,1-2.7,2.1 c-0.8,1.4-0.8,3,0,4.2l7.8,12.7c0.3-0.2,0.6-0.4,0.9-0.7l-7.7-12.7c-0.6-1-0.6-2.1,0-3.1C98.4,53.5,99.3,52.9,100.5,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8347AD",
    d: "M108.5,58.7l5.6,0c0.1-0.4,0.3-0.7,0.4-1.1l-5.9,0c-0.2,0-0.4,0-0.6,0.1c-0.8,0.2-1.5,0.7-1.9,1.4 c-0.5,0.9-0.5,2,0,2.9l3.1,5c0.3-0.3,0.5-0.6,0.7-0.9l-2.9-4.7c-0.5-0.8-0.2-1.5,0-1.8C107.1,59.3,107.6,58.6,108.5,58.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.9,
    y: 0,
    fill: "#E6E6E6",
    width: 35.7,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0,
    fill: "#E6E6E6",
    width: 35.7,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.4,
    y: 0,
    fill: "#E6E6E6",
    width: 35.7,
    height: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoleaLogo);
export default __webpack_public_path__ + "static/media/solea-logo.1ccb3c347da2cecfd6fb5cc513228e8a.svg";
export { ForwardRef as ReactComponent };